import { renderCard } from './card';
import { Title } from './title';
import './ai.less';

const bookCourseList = [
    {
        title: '动手学数据结构与算法',
        intro:
            '以火车票管理系统为载体，注重理论、算法设计与代码实现，助力掌握数据结构与算法知识。',
        id: `hds`,
        listImage:
            'https://staticcdn.boyuai.com/user-assets/14398/s4ccsvrS37BoxBhKxi5Z1D/hds (1).png!png',
        staticLink: 'https://hds.boyuai.com/',
    },
    {
        title: '动手学机器学习',
        intro:
            '为人工智能领域学习者，清晰讲解机器学习基础，适应人工智能发展需求。',
        id: `hml`,
        listImage:
            'https://staticcdn.boyuai.com/user-assets/14398/YFfYDVV8JoA4oVWfg2ztdy/hml.png!png',
        staticLink: 'https://hml.boyuai.com/',
    },
    {
        title: '动手学自然语言处理',
        intro:
            '从词的表示入手，由浅入深介绍主流 NLP 算法，助力学习自然语言处理。',
        id: `hnlp`,
        listImage:
            'https://staticcdn.boyuai.com/user-assets/14398/pD1oyUv5DDrGv2At9TqyiE/hnlp.png!png',
        staticLink: 'https://hnlp.boyuai.com/',
    },
    {
        title: '动手学计算机视觉',
        intro: '提供友好学习环境，助读者学习计算机视觉知识，明晰代码实现过程。',
        id: `hcv`,
        listImage:
            'https://staticcdn.boyuai.com/user-assets/14398/sqCer3MT2K1sBs3HnY1JZc/hcv.png!png',
        staticLink: 'https://hcv.boyuai.com/',
    },
    {
        title: '动手学强化学习',
        intro:
            '打造友好 RL 学习环境，帮助读者掌握强化学习知识，理清代码实现思路。',
        id: `hml`,
        listImage:
            'https://staticcdn.boyuai.com/user-assets/14398/X2ayde6oHFKunDbmnhbbLw/hrl.png!png',
        staticLink: 'https://hrl.boyuai.com/',
    },
];

const BookCourses = () => {
    return (
        <div id="books" className="books" style={{ paddingBottom: 16 }}>
            <img
                style={{
                    position: 'absolute',
                    top: -60,
                    right: 50,
                }}
                alt="top-right-decoration"
                src="https://staticcdn.boyuai.com/materials/2020/11/12/pFc1f0vP0g90FQ9768v_F.svg"
            />
            <Title
                title="动手学系列丛书"
                intro="源于上海交大ACM班的人工智能专业课程，培养卓越AI算法工程师、研究员"
            />
            <div className="specs">
                <div className="spec">
                    <img
                        alt="ACM"
                        src="https://staticcdn.boyuai.com/materials/2020/11/12/HaLKWAR-9WaHRJfRXmSG7.svg"
                    />
                    <span>上交 ACM 班理论体系</span>
                </div>
                <div className="spec">
                    <img
                        alt="team"
                        src="https://staticcdn.boyuai.com/materials/2020/11/12/tJ0M3hWYEuaDpyEiea3nN.svg"
                    />
                    <span>顶尖高校教授团队</span>
                </div>
                <div className="spec">
                    <img
                        alt="individuality"
                        src="https://staticcdn.boyuai.com/materials/2020/11/12/A71v6KYYL39EWrbSS2u4l.svg"
                    />
                    <span>个性化学习路径</span>
                </div>
            </div>
            <div className="courses-wrapper" style={{ marginTop: 64 }}>
                <div className="courses">
                    {bookCourseList.map((c, i, arr) => {
                        const listNum = arr.length;
                        const isLastLine =
                            i >= listNum - (listNum % 5) && i < listNum;
                        return renderCard(
                            c,
                            Boolean(c.staticLink),
                            false,
                            isLastLine
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export { BookCourses };
